import { TABLE_CONTAINER_ID } from "./settings";

export function getPdfPage(pageNumber, proposalTablePosition=-1) {
  return document.querySelector(
    pageNumber === proposalTablePosition
      ? `#${TABLE_CONTAINER_ID}`
      : `div[data-page-number='${pageNumber}']`
  )
}